module.exports = __webpack_public_path__ + "img/print-icon.6b993078.svg";